import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-dynamic-task',
  templateUrl: './dynamic-task.component.html',
  styleUrls: ['./dynamic-task.component.scss']
})
export class DynamicTaskComponent extends ComponentBase implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

  getClassName(): string {
    return this.getOptionValue("class")
  }

  getIconClassName(): string {
    return this.getOptionValue("icon-class")
  }

  private getOptionValue(key: string) {
    let options = this.attribute.options

    if (options) {
      let classOpt = options.find(o => o.key.toLowerCase() == key)

      if (classOpt && classOpt.value) {
        return classOpt.value
      }
    }
  }

  getTaskName(): string {
    if(!this.attribute) {
      return 'Executar'
    }

    let titleOpt = this.attribute.options.find(opt => opt.key.toLowerCase() == "title")

    if(titleOpt) {
      return titleOpt.value
    }

    return this.attribute.key
  }

  execute() {
    this.emit({ attribute: this.attribute })
  }

  isCompleted(): boolean {
    if(!this.attribute) {
      return true
    }

    let matchOpt = this.attribute.options.find(opt => opt.key.toLowerCase() == "match")

    if(matchOpt) {
      return matchOpt.value.toLowerCase() == "true"
    }

    return false
  }

}
